/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { propertyCommodityCodeSchema } from "./propertyCommodityCodeSchema.ts";
import { z } from "zod";

/**
 * @description Commodités du bien — proposées par nature dans form-rules/property-form.json (champ commodities)
 */
export const propertyCommoditySchema = z.array(z.lazy(() => propertyCommodityCodeSchema).describe("Commodité du bien — libellés et compatibilité avec la nature dans form-rules/property-form.json (champ commodities)")).describe("Commodités du bien — proposées par nature dans form-rules/property-form.json (champ commodities)")